import { Navigate, useLocation } from 'react-router-dom';

interface RedirectPreservingSearchProps {
  to: string;
}

export function RedirectPreservingSearch({ to }: RedirectPreservingSearchProps) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}
